module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-27.a8ff5c4e.svg";